// Zoom simple et efficace pour les produits
document.addEventListener('DOMContentLoaded', function() {
  // Créer le modal de zoom
  const zoomModal = document.createElement('div');
  zoomModal.id = 'simple-zoom-modal';
  zoomModal.innerHTML = `
    <div class="zoom-overlay">
      <div class="zoom-content">
        <button class="zoom-close">&times;</button>
        <img class="zoom-image" src="" alt="">
        <video class="zoom-video" controls autoplay style="display: none;"></video>
      </div>
    </div>
  `;
  document.body.appendChild(zoomModal);
  
  // Styles CSS pour le zoom
  const style = document.createElement('style');
  style.textContent = `
    #simple-zoom-modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.9);
      z-index: 999999 !important;
      display: none;
      align-items: center;
      justify-content: center;
      opacity: 1;
      overflow: hidden;
    }
    
    
    .zoom-overlay {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;
      overflow: hidden;
    }
    
    .zoom-content {
      max-width: 95%;
      max-height: 95%;
      position: relative;
      cursor: default;
      z-index: 1000000;
      overflow: hidden;
    }
    
    .zoom-image,
    .zoom-video {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      overflow: hidden;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      width: auto;
      height: auto;
    }
    
    /* Amélioration pour desktop */
    @media screen and (min-width: 750px) {
      .zoom-content {
        max-width: 98%;
        max-height: 98%;
      }
      
      .zoom-image,
      .zoom-video {
        max-width: 100vw;
        max-height: 100vh;
        width: auto;
        height: auto;
      }
    }
    
    .zoom-close {
      position: absolute;
      top: -40px;
      right: 0;
      background: rgba(255, 255, 255, 0.8);
      border: none;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      font-size: 24px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000001;
    }
    
    .zoom-close:hover {
      background: rgba(255, 255, 255, 1);
    }
    
    /* Masquer la croix partout */
    .zoom-close {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
  
  // Fonction pour ouvrir le zoom
  function openZoom(src, isVideo = false) {
    if (isVideo) {
      zoomModal.querySelector('.zoom-video').src = src;
      zoomModal.querySelector('.zoom-video').style.display = 'block';
      zoomModal.querySelector('.zoom-image').style.display = 'none';
    } else {
      zoomModal.querySelector('.zoom-image').src = src;
      zoomModal.querySelector('.zoom-image').style.display = 'block';
      zoomModal.querySelector('.zoom-video').style.display = 'none';
    }
    
    zoomModal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    
    // Apparition instantanée
  }
  
  // Fonction pour fermer le zoom
  function closeZoom() {
    // Arrêter la vidéo si elle est en cours
    const video = zoomModal.querySelector('.zoom-video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    
    zoomModal.style.display = 'none';
    document.body.style.overflow = '';
  }
  
  // Gérer les clics sur les images et vidéos
  document.addEventListener('click', function(e) {
    const mediaItem = e.target.closest('.product__media-item');
    if (mediaItem) {
      const img = mediaItem.querySelector('img');
      const video = mediaItem.querySelector('video');
      
      if (img || video) {
        e.preventDefault();
        e.stopPropagation();
        
        // Replier le menu sur desktop
        const header = document.querySelector('.header');
        if (header) {
          header.classList.remove('menu-open');
        }
        
        // Fermer les dropdowns du menu
        const menuDropdowns = document.querySelectorAll('.header__menu-item--has-dropdown');
        menuDropdowns.forEach(dropdown => {
          dropdown.classList.remove('open');
        });
        
        // Priorité à la vidéo si elle existe
        if (video) {
          // Vidéo - récupérer la source vidéo
          let videoSrc = video.src;
          // Vidéo détectée
          
          if (!videoSrc) {
            const source = video.querySelector('source');
            if (source) {
              videoSrc = source.src;
              // Source depuis <source>
            }
          }
          
          if (videoSrc) {
            // Ouverture vidéo
            openZoom(videoSrc, true);
          } else {
            // Aucune source vidéo trouvée
          }
        } else if (img) {
          // Image seulement
          // Image détectée
          openZoom(img.src, false);
        }
      }
    }
  });
  
  // Fermer le zoom en cliquant sur l'overlay (pas sur le contenu)
  zoomModal.addEventListener('click', function(e) {
    if (e.target === zoomModal || e.target.classList.contains('zoom-overlay')) {
      closeZoom();
    }
  });
  
  // Fermer avec le bouton
  zoomModal.querySelector('.zoom-close').addEventListener('click', function(e) {
    e.stopPropagation();
    closeZoom();
  });
  
  // Fermer avec Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && zoomModal.style.display === 'flex') {
      closeZoom();
    }
  });
});
